import * as React from "react";
import { IconButton, Box } from "@mui/material";
import { RATING_OPTIONS } from "./ratingOptions";

export default function SymbolRating({ value, onChange }) {
  const [localValue, setLocalValue] = React.useState(value);

  React.useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <Box sx={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
      {RATING_OPTIONS.map((option) => {
        const isSelected = 
          localValue !== "" && 
          localValue !== undefined && 
          Number(localValue) === Number(option.value);

        const IconComponent = option.icon;

        return (
          <IconButton
            key={option.key || option.value}
            size="small"
            onClick={() => {
              const newValue = isSelected ? "" : option.value;
              setLocalValue(newValue);
              onChange(newValue);
            }}
            sx={{
              zIndex: 0,
              transform: isSelected ? "scale(1.15)" : "scale(1)",
              transition: "all 0.2s ease-in-out",
              
              bgcolor: isSelected ? option.color : "transparent",
              border: "none",
              
              // تم رفع الشفافية هنا لتصبح الأيقونات واضحة ولكن غير مزعجة
              opacity: isSelected ? 1 : 0.85,

              "&:hover": {
                transform: "scale(1.1)",
                opacity: 1, 
                bgcolor: isSelected ? option.color : `${option.color}15`,
              },
            }}
          >
            <IconComponent 
              size={20} 
              color={isSelected ? "#ffffff" : option.color} 
              style={{ transition: "color 0.2s ease-in-out" }}
            />
          </IconButton>
        );
      })}
    </Box>
  );
}